module.exports = __webpack_public_path__ + "static/reel2-f37c708f315bda74d763e7f1fb7ebeb7.mp4";